export default "__VITE_ASSET__BYfEbhJr__"